import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PublicFicha from "./pages/PublicFicha";
import PublicPesquisa from "./pages/PublicPesquisa";
import { AuthProvider } from "./contexts/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Formulários públicos (sem login): ?f=<token> credenciamento, ?p=<token> pesquisa
const params = new URLSearchParams(window.location.search);
const fichaToken = params.get("f");
const pesquisaToken = params.get("p");

root.render(
  fichaToken ? (
    <PublicFicha token={fichaToken} />
  ) : pesquisaToken ? (
    <PublicPesquisa token={pesquisaToken} />
  ) : (
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  )
);
